export default [
  {
    title: 'breadcrumb.liveBet',
    route: 'live-bet',
    icon: '',
    resource: 'live-bet',
    action: 'read',
  }
];